(function () {
  'use strict';

  function initializeCarousel(carousel) {
    if (!carousel || carousel.dataset.variantThumbnailInitialized === 'true') return;

    var track = carousel.querySelector('[data-variant-thumbnail-track]');
    var previous = carousel.querySelector('[data-variant-thumbnail-previous]');
    var next = carousel.querySelector('[data-variant-thumbnail-next]');

    if (!track) return;

    carousel.dataset.variantThumbnailInitialized = 'true';

    function isScrollable() {
      return track.scrollWidth > track.clientWidth + 1;
    }

    function updateControls() {
      var scrollable = isScrollable();
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

      carousel.classList.toggle('is-scrollable', scrollable);

      if (previous) previous.disabled = !scrollable || track.scrollLeft <= 1;
      if (next) next.disabled = !scrollable || track.scrollLeft >= maxScroll - 1;
    }

    function scrollStep() {
      var item = track.querySelector('.ProductForm__VariantThumbnailItem');
      if (!item) return track.clientWidth;

      var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    if (previous) {
      previous.addEventListener('click', function () {
        track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateControls, { passive: true });

    track.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        input.closest('.ProductForm__VariantThumbnailItem').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateControls).observe(track);
    } else {
      window.addEventListener('resize', updateControls);
    }

    updateControls();
  }

  function initializeAll(root) {
    (root || document).querySelectorAll('[data-variant-thumbnail-carousel]').forEach(initializeCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
